import * as Styled from 'components/ToolkitV2/BulletedList/BulletedListItem/BulletedListItem.styled';
import type { BulletedListItemProps } from 'components/ToolkitV2/BulletedList/BulletedListItem/BulletedListItem.typed';
import React from 'react';

export const BulletedListItem = (props: BulletedListItemProps) => {
  const { children } = props;
  return <Styled.ListItem>{children}</Styled.ListItem>;
};
